













































































































































































import { getRegions } from '@/api/Address/address'
import { getAgencies } from '@/api/Agency/agency.api'
import {
  getTariffs,
  updateMultipleTariff,
} from '@/api/Remittances/remittances.api'
import { Paginator, Params, VueForm, VueTable } from '@/utils/interfaces'
import {
  DeliveryCurrenciesEnum,
  Tariff,
} from '@/utils/interfaces/remittance.interface'
import vRules from '@/utils/vRules'
import { AxiosResponse } from 'axios'
import Vue from 'vue'
import { Agency } from '~/api/Agency/agency.interface'
import Autocomplete from './Autocomplete.vue'
import CreateDialog from './CreateDialog.vue'
import FlatTable from './FlatTable.vue'
import TextButton from './TextButton.vue'
export default Vue.extend({
  components: {
    CreateDialog,
    Autocomplete,
    TextButton,
    FlatTable,
  },
  props: {
    type: {
      type: String,
      default: 'CLIENT',
    },
  },
  data() {
    return {
      update_client_exchange: false,
      dialog: false,
      loading: false,
      crud: {
        exchange_rate: {
          model: '' as string,
          enabled: true,
        },
        min_commission: {
          model: '' as string,
          enabled: true,
          props: {
            prefix: '$',
          },
        },
        percent_commission: {
          model: '' as string,
          enabled: true,
          props: {
            suffix: '%',
          },
        },
        min_amount: {
          model: '' as string,
          enabled: false,
          props: {
            prefix: '$',
          },
        },
        max_amount: {
          model: '' as string,
          enabled: false,
          props: {
            prefix: '$',
          },
        },
      },
      vRules,
      selectedTariffs: [] as Tariff[],
      availableTariffs: [] as Tariff[],
      toRemoveTariffs: [] as Tariff[],
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('interval') + ' ($)',
          value: 'interval',
        },
        {
          text: this.$t('minimum-commission') + ' ($)',
          value: 'min_commission',
        },
        {
          text: this.$t('percent-commission') + ' (%)',
          value: 'percent_commission',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('exchange_rate'),
          value: 'exchange_rate',
        },
        {
          text: this.$t('province'),
          value: 'region_name',
        },
      ],
      filter: {
        to_agency__uuid__in: [],
      },
      currencies: Object.values(DeliveryCurrenciesEnum),
      agencies: [] as Agency[],
    }
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        const body = {} as { [key: string]: string | undefined }
        Object.entries(this.crud).map(
          ([key, value]) =>
            (body[key] = value.enabled ? value.model : undefined),
        )
        await updateMultipleTariff({
          ...body,
          tariffs: this.selectedTariffs.map(tariff => tariff.uuid),
          update_client_exchange: this.update_client_exchange,
        })
        this.dialog = false
        this.update_client_exchange = false
        this.selectedTariffs = []
        this.toRemoveTariffs = []
        this.$emit('new-updates')
      } finally {
        this.loading = false
      }
    },
    onAdd() {
      this.selectedTariffs.push(...this.availableTariffs)
      this.availableTariffs = []
    },
    onRemove() {
      this.selectedTariffs = this.selectedTariffs.filter(
        tariff => !this.toRemoveTariffs.find(item => item.uuid === tariff.uuid),
      )
    },
    onFilter() {
      const table = this.$refs.table as VueTable
      table.newFilter({
        ...this.filter,
        to_agency__uuid__in: this.filter.to_agency__uuid__in?.join(','),
      })
    },
    getRegions: (params?: Params) =>
      getRegions({ ...params, country__name: 'Cuba' }),
    getAgencies,
  },
  computed: {
    getter(): (params?: Params) => Promise<AxiosResponse<Paginator<Tariff>>> {
      return async (params?: Params) => {
        const response = await getTariffs({
          ...params,
          type: this.type,
          agency__uuid: this.$store.state.profile.agency,
        })
        const vm = this
        response.data.results = response.data.results.map(item => ({
          ...item,
          get isSelectable() {
            return !vm.selectedTariffs.find(tariff => tariff.uuid === item.uuid)
          },
        }))
        return response
      }
    },
  },
  watch: {
    dialog(value: boolean) {
      if (value) {
        this.selectedTariffs = []
        this.toRemoveTariffs = []
        this.update_client_exchange = false
      }
    },
  },
  async mounted() {
    const response = await getAgencies({ limit: 1000 })
    this.agencies = response.data.results
  },
})
